import React, { useEffect, useContext, useState } from "react";
import { useDropzone } from "react-dropzone";
import ViewerContext from "../../context/ViewerContext";
function DropArea() {
  const { setLoadedFileDataList } = useContext(ViewerContext);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onFileDrop,
    noClick: true,
    noKeyboard: true,
    multiple: true,
  });

  const [disableDropArea, setDisableDropArea] = useState(false);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const singleFilePath = urlParams.get("file");
    const multiFilePath = urlParams.get("files");
    const sceneParam = urlParams.get("scene");

    if (singleFilePath || multiFilePath || sceneParam) {
      setDisableDropArea(true);
      return;
    }

    const dropZone = document.getElementById("dropzone");
    dropZone.style.display = "none";

    window.addEventListener("dragenter", showDropZone);
    dropZone.addEventListener("dragenter", allowDrag);
    dropZone.addEventListener("dragover", allowDrag);
    dropZone.addEventListener("dragleave", hideDropZone);

    return () => {
      window.removeEventListener("dragenter", showDropZone);
      dropZone.removeEventListener("dragenter", allowDrag);
      dropZone.removeEventListener("dragover", allowDrag);
      dropZone.removeEventListener("dragleave", hideDropZone);
    };
  }, []);

  function showDropZone() {
    const dropZone = document.getElementById("dropzone");
    dropZone.style.display = "flex";
  }

  function hideDropZone() {
    const dropZone = document.getElementById("dropzone");
    dropZone.style.display = "none";
  }

  function allowDrag(e) {
    if (true) {
      e.dataTransfer.dropEffect = "copy";
      e.preventDefault();
    }
  }

  function findFileType(file) {
    const fileExtension = file.name.split(".").pop();
    if (fileExtension === "igc") return "igc";

    return null;
  }

  function onFileDrop(acceptedFiles) {
    hideDropZone();
    setLoadedFileDataList(acceptedFiles);
    //todo check type
    const type = findFileType(acceptedFiles[0]);
  }

  return (
    <>
      {" "}
      {!disableDropArea && (
        <div
          {...getRootProps()}
          id="dropzone"
          style={{
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            opacity: isDragActive ? 0.7 : 0,
            transition: "opacity 0.2s ease-in-out",
            borderStyle: "dashed",
            borderRadius: "10px",
            borderColor: "white",
            borderWidth: "2px",
            zIndex: 100,
          }}
        >
          <input {...getInputProps()} />
          <p
            style={{
              color: "#fff",
              fontSize: "24px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Drop the file here
          </p>
        </div>
      )}
    </>
  );
}

export default DropArea;
